import styled, { css } from 'styled-components';
import { EMPTY_STATE_SIZE } from '../../global/constants';
import { Typography } from '../../global/theme';
import { FlexCenter } from '../../global/commonStyle';

interface Props {
  size?: number;
  isAlignedCenter?: boolean;
}

export const Group = styled.div<Props>`
  max-width: ${({ size }) => (size === EMPTY_STATE_SIZE.SMALL ? '240px' : '320px')};
  width: 100%;
  ${FlexCenter}
  flex-direction: column;
  gap: ${({ size }) => (size === EMPTY_STATE_SIZE.SMALL ? 'var(--space-12)' : 'var(--space-16)')};
  ${({ isAlignedCenter }) =>
    isAlignedCenter &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;

// detail section
export const TitleSection = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: ${({ size }) => (size === EMPTY_STATE_SIZE.SMALL ? 'var(--space-3)' : 'var(--space-4)')};
  text-align: center;
`;

export const Title = styled.p<Props>`
  margin: var(--space-0);
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  ${({ size }) =>
    size === EMPTY_STATE_SIZE.SMALL &&
    css`
      ${Typography.body_md_semibold}
    `}
`;

export const Description = styled.p`
  margin: var(--space-0);
  ${Typography.body_md}
  color: var(--text-secondary);
`;
